import { render, staticRenderFns } from "./boundConsultation.vue?vue&type=template&id=088138d4&scoped=true&"
import script from "./boundConsultation.vue?vue&type=script&lang=js&"
export * from "./boundConsultation.vue?vue&type=script&lang=js&"
import style0 from "./boundConsultation.vue?vue&type=style&index=0&id=088138d4&prod&scoped=true&lang=less&"
import style1 from "./boundConsultation.vue?vue&type=style&index=1&id=088138d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088138d4",
  null
  
)

export default component.exports